import { configureStore } from '@reduxjs/toolkit';

import bannerReducer from './menu/BannersSlice';
import productReducer from './menu/ProductSlice';
import categoriesReducer from './menu/CategoriesSlice';
import profileReducer from './menu/ProfileSlice';
import CartReducer from './menu/cartSlice';
import storesReducer from './menu/StoresSlice';
import favoritesReducer from './menu/favoritesSlice';


export const store = configureStore({
  reducer: {
    category: categoriesReducer,
    product: productReducer,
    banner: bannerReducer,
    profile: profileReducer,
    cart : CartReducer,
    stores: storesReducer,
    favorites: favoritesReducer,
  },
});
